var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrafficLayerEnabledHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "158.8%",
    height: "158.8%",
    x: "-29.4%",
    y: "-26.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.298039216 0 0 0 0 0.345098039 0 0 0 0 0.384313725 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#a)",
    transform: "translate(-2 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M25.706 14.778h-3.309V13.51a4.44 4.44 0 0 0 3.309-4.289h-3.309v-1.11A1.11 1.11 0 0 0 21.294 7h-8.823c-.607 0-1.103.5-1.103 1.111v1.111h-3.31a4.44 4.44 0 0 0 3.31 4.29v1.266h-3.31a4.44 4.44 0 0 0 3.31 4.289v1.266h-3.31a4.44 4.44 0 0 0 3.31 4.29v1.266A1.11 1.11 0 0 0 12.47 27h8.823c.607 0 1.103-.5 1.103-1.111v-1.267a4.44 4.44 0 0 0 3.309-4.289h-3.309v-1.266a4.44 4.44 0 0 0 3.309-4.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00C46C",
    d: "M16.882 24.778c-1.224 0-2.206-1-2.206-2.222 0-1.223.982-2.223 2.206-2.223 1.214 0 2.206 1 2.206 2.223a2.213 2.213 0 0 1-2.206 2.222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1BE00",
    d: "M16.882 19.222c-1.224 0-2.206-1-2.206-2.222s.982-2.222 2.206-2.222c1.214 0 2.206 1 2.206 2.222a2.213 2.213 0 0 1-2.206 2.222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3B64",
    d: "M16.882 13.667c-1.224 0-2.206-1-2.206-2.223 0-1.233.982-2.222 2.206-2.222 1.214 0 2.206.99 2.206 2.222a2.213 2.213 0 0 1-2.206 2.223"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficLayerEnabledHover);
export default __webpack_public_path__ + "static/media/traffic-layer-enabled-hover.272a8c440c20f81edcefae04788f359b.svg";
export { ForwardRef as ReactComponent };